import React from 'react'
import Clip from '../components/HtmlMainPage/images/clip.png'
import { Spinner } from 'react-bootstrap'

const CommonFileUploader = ({
    handlePhoto,
    onFileSelect,
    fileName,
    duplicateError,
    accept,
    loading,
    name,
    id,
    placeholder = "Choose file"
}) => {
    const onChangeHandler = onFileSelect || handlePhoto;
    return (
        <div>
            <label className="file-input-label d-flex align-items-center mt-2" style={{ overflow: 'hidden', cursor: 'pointer' }}>
                <span><img className='clip-image' src={Clip} alt="clip" /></span>
                <input
                    type="file"
                    id={id || name || "addressProof"}
                    name={name}
                    className="file-input"
                    onChange={onChangeHandler}
                    disabled={duplicateError === "vip" || duplicateError === "true"}
                    style={{
                        background: `${(duplicateError === "vip" || duplicateError === "true") ? "#cdcdcd" : "#fff"}`,
                        cursor: 'pointer'
                    }}
                    accept={accept}
                />
                <span
                    className={`placeholder-text ${loading ? `d-flex align-items-center gap-2` : ``}`}
                    style={{
                        opacity: loading ? 0.7 : 1,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        paddingRight: '10px'
                    }}
                >
                    {loading ? (
                        <>
                            <Spinner animation="border" size="sm" /> <span>Loading...</span>
                        </>
                    ) : (
                        fileName || placeholder
                    )}
                </span>
            </label>
        </div>
    )
}

export default CommonFileUploader